import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import asyncComponent from './hoc/AsyncComponent';
import Loading from './modules/Loading';
import PrivateRoute from "./Routes";
import {connect} from "react-redux";
import {getVendorInfo} from "../selectors/vendor";

const AsyncNotFound = asyncComponent(() => import('./pages/NotFound'));
const AsyncEntrypoint = asyncComponent(() => import('./pages/Home/Entrypoint'));
const AsyncAuthentication = asyncComponent(() => import('./pages/Authentication'));
const AsyncPayment = asyncComponent(() => import('./pages/Payment'));
const AsyncPaymentV2 = asyncComponent(() => import('./pages/PaymentV2'));
const AsyncPlans = asyncComponent(() => import('./pages/Plans'));
const AsyncSuccess = asyncComponent(() => import('./pages/Success'));
const AsyncSuccessV2 = asyncComponent(() => import('./pages/SuccessV2'));
const AsyncError = asyncComponent(() => import('./pages/Error'));
const AsyncErrorV2 = asyncComponent(() => import('./pages/ErrorV2'));
const AsyncInformation = asyncComponent(() => import('./pages/Information'));
const AsyncVendorInformation = asyncComponent(() => import('./pages/VendorInformation'));
const AsyncCreditCard = asyncComponent(() => import('./pages/ChangeCreditCard'));
const AsyncCreditCardSuccess = asyncComponent(() => import('./pages/ChangeCreditCardSuccess'));
const AsyncVendor = asyncComponent(() => import('./pages/Vendor'));

class App extends Component {
  render() {
    return (
      <Fragment>
        <Loading />
        <ConnectedRouter history={this.props.history}>
          <Switch>
            <Route path="/" exact component={AsyncEntrypoint} />
            <Route path="/selecionar-plano" exact component={AsyncPlans} />
            <Route path="/confirmacao-sms" exact component={AsyncAuthentication} />
            <Route path="/pagamento" exact component={AsyncPayment} />
            <Route path="/pagamentov2" exact component={AsyncPaymentV2} />
            <Route path="/sucesso" exact component={AsyncSuccess} />
            <Route path="/sucesso-v2" exact component={AsyncSuccessV2} />
            <Route path="/error" exact component={AsyncError} />
            <Route path="/error-v2" exact component={AsyncErrorV2} />
            <Route path="/dados" exact component={AsyncInformation} />
            <PrivateRoute path="/vendas" exact component={AsyncVendorInformation} isAuthenticated={this.props.vendorInfo}/>
            <Route path="/trocar-cartao" exact component={AsyncCreditCard} />
            <Route path="/sucesso-troca-cartao" exact component={AsyncCreditCardSuccess} />
            <Route path="/vendedor" exact component={AsyncVendor} />
            <Route component={AsyncNotFound} />
          </Switch>
        </ConnectedRouter>
      </Fragment>
    );
  }
}

App.propTypes = {
  history: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ vendorInfo: getVendorInfo(state) });
export default connect(
  mapStateToProps,
)(App);
